import { uploadFileToServer } from '@rs-core/utils/file';

const pdfUtil = {
	/**
	 * Download pdf
	 * @param {*} instance instance of @pdftron/webviewer
	 */
	download: (instance, fileName) => {
		if (!instance) return;
		const { documentViewer, annotationManager } = instance.Core;
		annotationManager.exportAnnotations().then(xfdfString => {
			const doc = documentViewer.getDocument();
			doc.getFileData({ xfdfString }).then(data => {
				const arr = new Uint8Array(data);
				const pdfBlob = new Blob([arr], { type: 'application/pdf' });
				const winURL = window.URL || window.webkitURL;
				const blobUrl = winURL.createObjectURL(pdfBlob, { type: 'application/pdf' });
				const anchorElem = document.createElement('a');
				anchorElem.href = blobUrl;
				anchorElem.download = fileName ? fileName : 'download.pdf';
				anchorElem.click();
				anchorElem.remove();
				winURL.revokeObjectURL(blobUrl);
			});
		});
	},

	/**
	 * Print pdf
	 * @param {*} instance instance of @pdftron/webviewer
	 */
	print: instance => {
		instance?.UI?.print();
	},

	/**
	 * upload pdf
	 * @param {*} instance instance of @pdftron/webviewer
	 * @param {*} url url to upload file
	 * @param {*} fileName pdf file name
	 */
	upload: async (instance, url, fileName) => {
		if (!instance) return false;
		const { documentViewer, annotationManager } = instance.Core;
		const xfdfString = await annotationManager.exportAnnotations();
		const doc = documentViewer.getDocument();
		const data = await doc.getFileData({ xfdfString });

		const arr = new Uint8Array(data);
		const pdfBlob = new File([arr], fileName, { type: 'application/pdf' });
		const fileData = new FormData();
		fileData.append('file', pdfBlob);

		const resData = await uploadFileToServer(url, fileData);

		if (resData && resData?.length > 0) {
			return resData?.length > 0;
		} else {
			return false;
		}
	},

	/**
	 * upload pdf
	 * @param {*} instance instance of @pdftron/webviewer
	 * @param {*} url url to upload file
	 * @param {*} fileName pdf file name
	 */
	uploadData: async (data, url, fileName) => {
		if (data) {
			const arr = new Uint8Array(data);
			const pdfBlob = new File([arr], fileName, { type: 'application/pdf' });
			const fileData = new FormData();
			fileData.append('file', pdfBlob);

			const resData = await uploadFileToServer(url, fileData);

			if (resData && resData?.length > 0) {
				return resData?.length > 0;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
};

export default pdfUtil;
